import {
  Button,
  Checkbox,
  Col,
  ColProps,
  FormInstance,
  Input,
  notification,
  Modal,
  Row,
  Select,
  Space,
  Typography,
} from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import TextArea from 'antd/lib/input/TextArea';
import AddressForm from '../shared/AddressFormFields';
import * as React from 'react';
import LookupsApiService from '../../api/LookupsApiService';
import SchEInKindContributionsApiService from '../../api/SchEInKindContributionsApiService';
import ScheduleApiService from '../../api/ScheduleApiService';
import CodeLookupTableDTO from '../../models/CodeLookupTableDTO';
import SchEInKindContributionsFormDTO from '../../models/SchEInKindContributionsFormDTO';
import CommitteeInfoDTO from '../../models/CommitteeInfoDTO';
import FormValidationUtil from '../../utils/FormValidationUtil';
import Dr2GroupTypes from '../../consts/Dr2GroupTypes';
import CurrentUser from '../../utils/CurrentUser';
import HistoryUtil from '../../utils/HistoryUtil';
import Routes from '../../consts/Routes';
import { RouteComponentProps } from 'react-router';
import { Content } from 'antd/lib/layout/layout';
import moment from 'moment';
import PersonSearch from '../shared/PersonSearch';
import BaseScheduleInfoDTO from '../../models/BaseScheduleInfoDTO';
import ExpenditureType from '../../consts/ExpenditureType';
import ScheduleAbbreviationCodes from '../../consts/ScheduleAbbreviationCodes';
import ExpenditureTypeDTO from '../../models/ExpenditureTypeDTO';
import SchEInKindContributionHistoryTable from './SchEInKindContributionHistoryTable';
import CommitteeAutoSearch from '../shared/CommitteeSearch';
import NotesModal from '../shared/NotesModal';
import NoteEntityParents from '../../consts/NoteEntityParents';
import CurrencyInput from '../shared/CurrencyInput';
import CustomDatePicker from '../shared/CustomDatePicker';
import CustomForm from '../shared/CustomForm';
import OrganizationAutoSearch from '../shared/OrganizationSearch';
import CommitteeType from '../../consts/CommitteeType';

const Option = Select.Option;
const confirm = Modal.confirm;

interface SchEInKindContributionsFormProps {
  id?: string;
  debtId?: string;
  seqNum?: string;
}

interface SchEInKindContributionsFormState {
  relations: CodeLookupTableDTO[];
  expenseTypes: ExpenditureTypeDTO[];
  currContrType: string;
  currExpenseType: string;
  currComm: CommitteeInfoDTO;
  btnDisable: boolean;
  contributionInfo: SchEInKindContributionsFormDTO;
  contributionId: string;
  debtId: string;
  startDt: moment.Moment;
  endDt: moment.Moment;
  debtAmt: number;
  loading: boolean;
  trusteeTrustorReq: boolean;
  seqNum: number;
  autoFillPerorg: boolean;
  hideRelationship: boolean;
}

class SchEInKindContributionsForm extends React.Component<RouteComponentProps<SchEInKindContributionsFormProps>, SchEInKindContributionsFormState> {
  private readonly _formRef = React.createRef<FormInstance>();

  constructor(props: RouteComponentProps<SchEInKindContributionsFormProps>) {
    super(props);
    this.state = {
      relations: [],
      expenseTypes: [],
      currContrType: '',
      currExpenseType: '',
      currComm: CommitteeInfoDTO.create(),
      btnDisable: false,
      contributionId: this.props.match.params.id || '',
      debtId: this.props.match.params.debtId || '',
      contributionInfo: SchEInKindContributionsFormDTO.create({
        contributorType: '',
        state: 'IA',
        relationshipCode: '',
        amount: null,
        expenseType: '',
      }),
      startDt: moment.utc(),
      endDt: moment.utc(),
      debtAmt: 0,
      loading: !!this.props.match.params.id || !!this.props.match.params.debtId,
      trusteeTrustorReq: false,
      seqNum: Number(this.props.match.params.seqNum) || 0,
      autoFillPerorg: false,
      hideRelationship: false,
    };
  }

  componentDidMount() {
    this.loadLookups();
    this.getUserCommittee();
    this.getSchedule();
    if (this.props.match.params.id) {
      this.getInKindContribution(this.props.match.params.id || '', this.props.match.params.seqNum || '');
    }
    else if (this.props.match.params.debtId) {
      this.getDebt(this.props.match.params.debtId || '', this.props.match.params.seqNum || '');
    }
  }

  render() {
    const { relations, expenseTypes, currContrType, currExpenseType, currComm, btnDisable,
      contributionId, contributionInfo, debtId, startDt, endDt, loading, trusteeTrustorReq,
      seqNum, autoFillPerorg, hideRelationship } = this.state;

    const columnSizingProps: ColProps = { xs: 24, sm: 24, md: 12 };
    const isCandidateCommittee = currComm.filerTypeName == 'Candidate';
    const isDebt = !!debtId;
    const relationReq = currContrType === Dr2GroupTypes.INDIVIDUAL && isCandidateCommittee;

    const explantionReqCodeArr: string[] = [];
    expenseTypes.forEach(e => {
      if (e.explanationRequired) {
        explantionReqCodeArr.push(e.code || '');
      }
    });

    const explanationReq = (currExpenseType && explantionReqCodeArr.indexOf(currExpenseType || '') >= 0);

    const contrTypes = [
      Dr2GroupTypes.INDIVIDUAL,
      Dr2GroupTypes.COMMITTEE,
      Dr2GroupTypes.TRUST,
      Dr2GroupTypes.COMPANYOTHER,
    ];

    const typeTooltip = expenseTypes.find(e => e.code === currExpenseType);

    return (
      <>
        {!loading &&
          <Content className="content-pad">
            <Typography.Title level={4}>Schedule E - In-Kind Contribution</Typography.Title>
            <CustomForm formRef={this._formRef} initialValues={contributionInfo} layout="vertical" onFinish={this.handleSave}>
              <Row gutter={24}>
                <Col {...columnSizingProps}>
                  <FormItem name="contributorType" label="Contributor Type"
                    rules={[FormValidationUtil.Required('Contributor Type is required')]} >
                    <Select
                      showSearch={!isDebt}
                      open={isDebt ? !isDebt : undefined}
                      optionFilterProp="children"
                      onChange={this.handleContrTypeChange}>
                      <Option value="" disabled={true}>-- Select Type --</Option>
                      {contrTypes.map(pt => (
                        <Option key={pt} value={pt}>{pt}</Option>
                      ))}
                    </Select>
                  </FormItem>
                  <FormItem name="date" label="Date"
                    rules={[FormValidationUtil.RequiredDate('Date is required'), FormValidationUtil.DateRange(startDt, endDt)]}>
                  <CustomDatePicker onChange={(d) => d?.startOf('day')}/>
                  </FormItem>
                  <FormItem name="expenseType" label="Type"
                    rules={[FormValidationUtil.Required('Type is required')]}
                    tooltip={typeTooltip ? typeTooltip.explanationDescription : 'Select a type'}
                  >
                    <Select
                      showSearch={!isDebt}
                      open={isDebt ? !isDebt : undefined}
                      optionFilterProp="children"
                      onSelect={this.handleExpenseTypeChange}
                    >
                      <Option value="" disabled={true}>-- Select Type --</Option>
                      {expenseTypes.map(et => (
                        <Option key={et.code || ''} value={et.code || ''}>{et.name}</Option>
                      ))}
                    </Select>
                  </FormItem>
                  <FormItem name="amount" label="Amount"
                    rules={[
                      FormValidationUtil.RequiredNumber('Amount is required'),
                      FormValidationUtil.NotNegativeNumber('Amount must be nonnegative')
                    ]}>
                    <CurrencyInput onChange={this.handleAmountChange}/>
                  </FormItem>
                  {isDebt && (
                    <FormItem name="amountRemaining" label="Amount Remaining"
                      rules={[FormValidationUtil.RequiredNumber('Amount Remaining is required', isDebt),
                      FormValidationUtil.NotNegativeNumber('Amount Remaining must not be negative')]}>
                      <CurrencyInput readOnly={true} />
                    </FormItem>
                  )}
                  <FormItem name="isFromFundraiser" valuePropName="checked">
                    <Checkbox> From Fundraiser </Checkbox>
                  </FormItem>
                  <FormItem name="explanation" label="Explanation"
                    rules={[FormValidationUtil.Required(
                      'Explanation is required',
                      explanationReq || currExpenseType === ExpenditureType.MISCELLANEOUS_OR_UNITEMIZED
                    )]}>
                    <TextArea maxLength={2000} />
                  </FormItem>
                </Col>
                <Col {...columnSizingProps}>
                  {currContrType === Dr2GroupTypes.INDIVIDUAL && (
                    <>
                      <PersonSearch
                        name={'person'}
                        label={'Search for an Individual'}
                        hidden={isDebt}
                        required={false}
                        committeeId={currComm.id || ''}
                        onSelect={this.getPerson}
                        onChange={this.handleContrChange}
                      />
                      {isDebt && (
                        <Row gutter={8}>
                          <Col flex="1">
                            <FormItem name={'firstName'} label={'First Name'}>
                              <Input readOnly={true} />
                            </FormItem>
                          </Col>
                          <Col flex="50px">
                            <FormItem name={'middleInitial'} label={'MI'}>
                              <Input readOnly={true} />
                            </FormItem>
                          </Col>
                          <Col flex="1">
                            <FormItem name={'lastName'} label={'Last Name'}>
                              <Input readOnly={true} />
                            </FormItem>
                          </Col>
                        </Row>
                      )}
                      <AddressForm allDisabled={autoFillPerorg}
                        firstName={{ name: 'firstName', hidden: isDebt }}
                        middleInitial={{ name: 'middleInitial', hidden: isDebt }}
                        lastName={{ name: 'lastName', hidden: isDebt }}
                        address1={{ name: 'addressLine1', hidden: isDebt }}
                        address2={{ name: 'addressLine2', hidden: isDebt }}
                        city={{ name: 'city', hidden: isDebt }}
                        state={{ name: 'state', hidden: isDebt }}
                        zip={{ name: 'zip', hidden: isDebt }}
                        phone={{ name: 'phoneNumber', required: false, hidden: isDebt }}
                      />
                      <FormItem name="relationshipCode" label="Relationship"
                        hidden={hideRelationship || isDebt}
                        rules={[FormValidationUtil.Required('Relationship is required', relationReq)]}>
                        <Select
                          showSearch disabled={autoFillPerorg}
                          optionFilterProp="children">
                          <Option value="" disabled={true}>-- Select Relationship --</Option>
                          {relations.map(rt => (
                            <Option key={rt.code || ''} value={rt.code || ''}>{rt.name}</Option>
                          ))}
                        </Select>
                      </FormItem>
                    </>
                  )}
                  {currContrType === Dr2GroupTypes.COMMITTEE && (
                    <>
                      {isDebt && (
                        <FormItem name={'contributorName'} label="Name">
                          <Input readOnly={true} />
                        </FormItem>
                      )}
                      <CommitteeAutoSearch
                        name="contributorName"
                        hidden={isDebt}
                        label="Name"
                        required={true}
                        requireSelection={true}
                        onSelectCommittee={this.handleCommitteeSelect}
                      />
                    </>
                  )}
                  {(currContrType === Dr2GroupTypes.COMPANYOTHER || currContrType === Dr2GroupTypes.TRUST) && (
                    <>
                      {isDebt && (
                        <FormItem name={'contributorName'} label="Name">
                          <Input readOnly={true} />
                        </FormItem>
                      )}
                      <OrganizationAutoSearch
                        name={'company'}
                        label={'Search for a Company'}
                        required={false}
                        hidden={isDebt}
                        committeeId={currComm.id || ''}
                        perorgType={currContrType}
                        onSelect={this.getOrganization}
                        onChange={this.handleContrChange}
                      />
                      <AddressForm allDisabled={autoFillPerorg}
                        name={{ name: 'contributorName', label: 'Company', hidden: isDebt }}
                        address1={{ name: 'addressLine1', hidden: isDebt }}
                        address2={{ name: 'addressLine2', hidden: isDebt }}
                        city={{ name: 'city', hidden: isDebt }}
                        state={{ name: 'state', hidden: isDebt }}
                        zip={{ name: 'zip', hidden: isDebt }}
                        phone={{ name: 'phoneNumber', required: false, hidden: isDebt }}
                      />
                    </>
                  )}
                  {currContrType === Dr2GroupTypes.TRUST &&
                    <>
                      <FormItem name="isLivingOrRevocableTrust" valuePropName="checked">
                        <Checkbox onChange={this.handleRevocableTrustCheckboxChange}>Living or Revocable Trust</Checkbox>
                      </FormItem>
                      <FormItem name="trustee" label="Trustee"
                        rules={[FormValidationUtil.Required('Trustee is required', trusteeTrustorReq)]}>
                        <Input disabled={autoFillPerorg} />
                      </FormItem>
                      <FormItem name="trustor" label="Trustor"
                        rules={[FormValidationUtil.Required('Trustor is required', trusteeTrustorReq)]}>
                        <Input disabled={autoFillPerorg} />
                      </FormItem>
                    </>
                  }
                </Col>
              </Row>
              <Row>
                <Col {...columnSizingProps}>
                  <FormItem name="contributorAutoFillId" hidden={true}>
                    <Input hidden={true} disabled={true} aria-hidden={true}/>
                  </FormItem>
                </Col>
              </Row>
              <Space>
                <Button type="primary" disabled={btnDisable} htmlType="submit" > Save Contribution </Button>
                <Button type="default" disabled={btnDisable} onClick={this.handleCancel}> Cancel </Button>
                {contributionId &&
                <NotesModal
                  parentId={contributionId}
                  parent={NoteEntityParents.INKINDCONTRIBUTION}
                  seqNum={seqNum || 0}
                  auditorsNoteId={contributionInfo.auditorsNoteId || ''} />
                }
              </Space>
            </CustomForm >
            {contributionId &&
              <SchEInKindContributionHistoryTable
                contributionId={contributionId || ''}
              />
            }
          </Content >
        }
      </>
    );
  }

  private handleContrTypeChange = (contrType: string) => {
    this.setState({
      currContrType: contrType,
      autoFillPerorg: false,
      trusteeTrustorReq: contrType == Dr2GroupTypes.TRUST
    });

    this._formRef.current?.setFieldsValue({
      'firstName': '',
      'middleInitial': '',
      'lastName': '',
      'relationshipCode': '',
      'addressLine1': '',
      'addressLine2': '',
      'city': '',
      'state': '',
      'zip': '',
      'phoneNumber': '',
      'trustee': '',
      'trustor': '',
      'person': null,
      'contributorName': null,
      'company': null,
      'isLivingOrRevocableTrust': false,
      'contributorAutoFillId': ''
    });

    if ([Dr2GroupTypes.COMPANYOTHER, Dr2GroupTypes.INDIVIDUAL, Dr2GroupTypes.TRUST].includes(contrType)) {
      this._formRef.current?.setFieldsValue({ state: 'IA' });
    }
  }

  private handleContrChange = (value: string) => {
    this._formRef.current?.setFieldsValue({ contributorAutoFillId: '' });
    this.setState({ autoFillPerorg: !!value });
  }

  private handleCommitteeSelect = (committee: CommitteeInfoDTO | undefined) => {
    this._formRef.current?.setFieldsValue({ contributorAutoFillId: committee?.id });
  }

  private handleExpenseTypeChange = (expenseType: string) => {
    this.setState({ currExpenseType: expenseType });
  }

  private handleAmountChange = (amount: any) => {
    if (this.state.debtId) {
      const newAmtRemaining = this.state.debtAmt - amount;
      this._formRef.current?.setFieldsValue({
        amountRemaining: newAmtRemaining
      });
    }
  }

  private setCompanyFields(form?: BaseScheduleInfoDTO) {
    if (form) {
      this._formRef.current?.setFieldsValue({
        contributorName: form.committeeOrCompanyName,
        addressLine1: form.addressLine1,
        addressLine2: form.addressLine2,
        city: form.city,
        state: form.state,
        zip: form.zip,
        phoneNumber: form.phoneNumber,
        trustee: form.trustee,
        trustor: form.trustor
      });
    }
    else {
      this._formRef.current?.setFieldsValue({
        contributorName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zip: '',
        phoneNumber: '',
        trustee: '',
        trustor: '',
        contributorAutoFillId: ''
      });
      this.setState({ autoFillPerorg: false });
    }
  }

  private setIndividualFields(form?: BaseScheduleInfoDTO) {
    if (form) {
      this._formRef.current?.setFieldsValue({
        contrType: form.groupType,
        firstName: form.firstName,
        middleInitial: form.middleInitial,
        lastName: form.lastName,
        addressLine1: form.addressLine1,
        addressLine2: form.addressLine2,
        city: form.city,
        state: form.state,
        zip: form.zip,
        phoneNumber: form.phoneNumber,
        relationshipCode: form.relationshipCode,
        contributorAutoFillId: ''
      });
    }
    else {
      this._formRef.current?.setFieldsValue({
        contrType: Dr2GroupTypes.INDIVIDUAL,
        firstName: '',
        middleInitial: '',
        lastName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zip: '',
        phoneNumber: '',
        relationshipCode: '',
        contributorAutoFillId: ''
      });
      this.setState({ autoFillPerorg: false });
    }
    this.setState({ currContrType: Dr2GroupTypes.INDIVIDUAL });
  }

  private handleRevocableTrustCheckboxChange = (e: any) => {
    this.setState({ trusteeTrustorReq: !e.target.checked });
  }

  private loadLookups = () => {
    const relationPromise = LookupsApiService.getRelationTypes();
    const expTypesPromise = LookupsApiService.getExpenditureTypes();
    Promise.all([relationPromise, expTypesPromise])
      .then(result => {
        const relations = result[0];
        let expenseTypes = result[1];
        if (this.state.contributionId) {
          // this.state.currExpenseType doesn't exist at this point...
          SchEInKindContributionsApiService.getInKindContribution(this.props.match.params.id || '', Number(this.props.match.params.seqNum))
            .then(result => {
              expenseTypes = expenseTypes.filter(et => et.code != ExpenditureType.REVERSE_TRANSACTION);
              if (result && result.expenseType !== ExpenditureType.MISCELLANEOUS_OR_UNITEMIZED) {
                expenseTypes = expenseTypes.filter(et => et.code != ExpenditureType.MISCELLANEOUS_OR_UNITEMIZED);
                this.setState({ relations: relations, expenseTypes: expenseTypes });
              }
            });
        }
        else {
          expenseTypes = expenseTypes.filter(et => et.code != ExpenditureType.MISCELLANEOUS_OR_UNITEMIZED
            && et.code != ExpenditureType.REVERSE_TRANSACTION);
        }
        this.setState({ relations: relations, expenseTypes: expenseTypes });
      });
  }

  private getSchedule = () => {
    ScheduleApiService.getSchedule(CurrentUser.Get()?.dr2Id || '', ScheduleAbbreviationCodes.SCHEDULEE)
      .then(schedule => {
        this.setState({ startDt: moment.utc(schedule.startDate), endDt: moment.utc(schedule.endDate) });
      });
  }

  private getPerson = (perorgId: string) => {
    if (perorgId != '') {
      ScheduleApiService.getPerson(perorgId, CurrentUser.Get()?.committeeId || '')
        .then(personInfo => {
          if (personInfo) {
            this.setIndividualFields(personInfo);
            this._formRef.current?.setFieldsValue({ contributorAutoFillId: perorgId });
          }
        });
    }
    else {
      this.setIndividualFields();
    }
  }

  private getOrganization = (perorgId: string) => {
    if (perorgId != '') {
      ScheduleApiService.getOrganization(perorgId, CurrentUser.Get()?.committeeId || '')
        .then(orgInfo => {
          if (orgInfo) {
            this.setCompanyFields(orgInfo);
            this._formRef.current?.setFieldsValue({ contributorAutoFillId: perorgId });
          }
        });
    }
    else {
      this.setCompanyFields();
    }
  }

  private getUserCommittee = () => {
    ScheduleApiService.getCommittee(CurrentUser.Get()?.committeeId || '')
      .then(committee => {
        if (committee) {
          const hideRelationshipCodes = [
            CommitteeType.CITY_PAC,
            CommitteeType.COUNTY_PAC,
            CommitteeType.IOWA_PAC,
            CommitteeType.SCHOOL_BOARD_OR_OTHER_POLITICAL_SUBDIVISION_PAC,
            CommitteeType.COUNTY_CENTRAL_COMMITTEE,
            CommitteeType.STATE_CENTRAL_COMMITTEE,
            CommitteeType.LOCAL_BALLOT_ISSUE];
          this.setState({ currComm: { ...committee }, hideRelationship: hideRelationshipCodes.includes(committee.committeeTypeCd || '') });
        }
      });
  }

  private getInKindContribution = (contributionId: string, seqNum: string) => {
    SchEInKindContributionsApiService.getInKindContribution(contributionId, Number(seqNum))
      .then(inKindContribution => {
        if (inKindContribution) {
          inKindContribution.date = moment(inKindContribution.date);

          const inKindContrInfo: SchEInKindContributionsFormDTO & { person?: string, company?: string } = inKindContribution;
          if (inKindContrInfo.firstName && inKindContrInfo.lastName) {
            if (inKindContrInfo.middleInitial) {
              inKindContrInfo.person = inKindContribution.firstName + ' ' + inKindContribution.middleInitial + '. ' + inKindContribution.lastName;
            }
            else {
              inKindContrInfo.person = inKindContribution.firstName + ' ' + inKindContribution.lastName;
            }
          }
          else if (inKindContrInfo.contributorType == Dr2GroupTypes.TRUST || inKindContrInfo.contributorType == Dr2GroupTypes.COMPANYOTHER) {
            if (inKindContrInfo.contributorName) {
              inKindContrInfo.company = inKindContrInfo.contributorName;
            }
          }

          this.setState({
            contributionInfo: inKindContribution,
            currContrType: inKindContribution.contributorType || '',
            currExpenseType: inKindContribution.expenseType || '',
            trusteeTrustorReq: inKindContribution.contributorType == Dr2GroupTypes.TRUST && !inKindContribution.isLivingOrRevocableTrust,
            autoFillPerorg: inKindContribution.contributorType != Dr2GroupTypes.COMMITTEE
          });
          this._formRef.current?.setFieldsValue(inKindContrInfo);
          this.setState({ loading: false });
        }
        else {
          notification.error({
            message: 'Error while fetching contribution',
            description: 'Not found'
          });
          this.setState({ loading: false });
        }
      }).catch(() => {
        notification.error({
          message: 'Error while fetching contribution'
        });
        this.setState({ loading: false });
      });
  }

  private getDebt = (debtId: string, seqNum: string) => {
    SchEInKindContributionsApiService.getDebt(debtId, Number(seqNum))
      .then(result => {
        if (result) {
          this.setState({
            contributionInfo: result,
            currContrType: result.contributorType || '',
            currExpenseType: result.expenseType || '',
            trusteeTrustorReq: result.contributorType == Dr2GroupTypes.TRUST && !result.isLivingOrRevocableTrust
          });
          this._formRef.current?.setFieldsValue(this.state.contributionInfo);
          this.setState({ loading: false, debtAmt: result.amountRemaining || 0 });
        }
        else {
          notification.error({
            message: 'Error while fetching debt',
            description: 'Not found'
          });
          this.setState({ loading: false });
        }
      }).catch(() => {
        notification.error({
          message: 'Error while fetching debt'
        });
        this.setState({ loading: false });
      });
  }

  private handleSave = (values: SchEInKindContributionsFormDTO) => {
    if (values.contributorAutoFillId === '') {
      values.contributorAutoFillId = null;
    }
    this.setState({ btnDisable: true });
    if (!this.state.contributionId && !this.state.debtId) {

      SchEInKindContributionsApiService.add(values, CurrentUser.Get()?.committeeId || '', CurrentUser.Get()?.dr2Id || '')
        .then(() => {
          notification.success({
            message: 'Saved Successfully',
            description: ''
          });
          HistoryUtil.push(Routes.SCHEDULE_E_IN_KIND_CONTRIBUTIONS);
        }).catch(error => {
          notification.error({
            message: 'Your contribution failed to save',
            description: error.message
          });
          HistoryUtil.push(Routes.SCHEDULE_E_IN_KIND_CONTRIBUTIONS);
        });
    }
    else if (this.state.contributionId && !this.state.debtId) {
      SchEInKindContributionsApiService.edit(
        values,
        CurrentUser.Get()?.committeeId || '',
        CurrentUser.Get()?.dr2Id || '',
        this.props.match.params.id || '',
        Number(this.props.match.params.seqNum)
      )
        .then(() => {
          notification.success({
            message: 'Saved Successfully',
            description: ''
          });
          HistoryUtil.push(Routes.SCHEDULE_E_IN_KIND_CONTRIBUTIONS);
        }).catch(error => {
          notification.error({
            message: 'Your contribution failed to save',
            description: error.message
          });
          HistoryUtil.push(Routes.SCHEDULE_E_IN_KIND_CONTRIBUTIONS);
        });
    }
    else {
      SchEInKindContributionsApiService.addWithDebt(
        values,
        CurrentUser.Get()?.committeeId || '',
        CurrentUser.Get()?.dr2Id || '',
        this.props.match.params.debtId || '',
        Number(this.props.match.params.seqNum)
      )
        .then(() => {
          notification.success({
            message: 'Saved Successfully',
            description: ''
          });
          HistoryUtil.push(Routes.SCHEDULE_D_DEBTS);
        }).catch(() => {
          notification.error({
            message: 'Your contribution failed to save',
            description: ''
          });
          HistoryUtil.push(Routes.SCHEDULE_D_DEBTS);
        });
    }
  }

  private handleCancel = () => {
    confirm({
      title: 'Are you sure you want to leave?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        HistoryUtil.push(this.state.debtId ? Routes.SCHEDULE_D_DEBTS : Routes.SCHEDULE_E_IN_KIND_CONTRIBUTIONS);
      }
    });
  }
}

export default SchEInKindContributionsForm;